module.exports = __webpack_public_path__ + "static/Graphik-Regular-Web-c0169aaed475244cdeb2f8b4acc407fd.woff";